import React, { useEffect } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { ChevronRight, Update } from "@mui/icons-material";
import { useAuthenticationStore } from "../../../stores/auth";
import { useNavigate } from "react-router-dom";
import FruitifyIcon from "../../../shared-components/FruitifyIcons";

const DashboardAction = ({
  title,
  subtitle,
  iconName,
  onClick,
  comingSoon = false,
}) => {
  return (
    <Box sx={{ position: "relative", width: "100%", display: "block" }}>
      <Box
        sx={{
          pointerEvents: comingSoon && "auto",
          opacity: comingSoon && 0.6,
          filter: comingSoon && "blur(1px)",
        }}
      >
        <Card variant="outlined" data-testid={`${title}-card`}>
          <FruitifyIcon name={iconName} variant="background" />
          <CardContent sx={{ mt: 2, mb: 2 }}>
            <Typography variant="h5">{title}</Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
          </CardContent>
          <Button
            sx={{ width: "100%" }}
            variant="outlined"
            endIcon={<ChevronRight />}
            onClick={onClick}
          >
            View
          </Button>
        </Card>{" "}
      </Box>

      {/* Overlay */}
      {comingSoon && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 1, // optional
          }}
        >
          <Tooltip title={"This feature is coming soon"} arrow>
            <Update
              sx={{ fontSize: 40, color: "primary.main", cursor: "help" }}
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

function SchoolGroupUserDashboard() {
  const { user } = useAuthenticationStore();
  const schoolGroup = user.info.activeContext?.roleAssignment?.schoolGroup;
  const navigate = useNavigate();

  useEffect(() => {
    // TODO: for now we just redirect to the schools page
    if (schoolGroup) {
      navigate(`/schoolGroup/${schoolGroup.id}/schools`);
    }
  }, [schoolGroup]);
  return (
    <FruitifyContainer>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        sx={{ mb: 3 }}
      >
        <Avatar />

        <Box>
          <Typography variant="h5">
            Welcome back, {user.info.firstName}!
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={4} direction={"row"}>
        <Grid size={{ xs: 12, md: 4 }}>
          <DashboardAction
            title={"View schools"}
            subtitle={"View your schools, their classes and assignments"}
            iconName={"School"}
            onClick={() => navigate(`/schoolGroup/${schoolGroup.id}/schools`)}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <DashboardAction
            comingSoon
            title={"Manage teachers"}
            subtitle={
              "Manage teachers including adding new members and allocating to classes"
            }
            iconName={"Teacher"}
            onClick={() => navigate("/management/teachers")}
          />
        </Grid>{" "}
        <Grid size={{ xs: 12, md: 4 }}>
          <DashboardAction
            comingSoon
            title={"Manage students"}
            subtitle={
              "Manage students including adding students and allocating to classes"
            }
            iconName={"Student"}
            onClick={() => navigate("/management/students")}
          />
        </Grid>
      </Grid>
    </FruitifyContainer>
  );
}

export default SchoolGroupUserDashboard;
